<template>
  <v-container
    id="about"
    fluid
    class="pa-0 ma-0 py-5 top-section"
    style="min-height: 60vh;"
  >
    <v-row justify="center" class="text-center my-10">
      <v-col cols="12">
        <span class="title font-weight-regular grey--text text--lighten-2"
          >A Few Words</span
        >
        <br /><span
          class="display-1 font-weight-medium grey--text text--lighten-2"
          >About Me</span
        >
      </v-col>

      <v-col cols="12" class="ma-0 py-0">
        <v-row justify="center">
          <v-col cols="2" class="ma-0 pa-0">
            <hr class="line-divider" />
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row
      class="grey--text text--lighten-2 pb-5"
      justify="center"
      align="center"
    >
      <v-col cols="10">
        <v-row justify="center" align="center" class="mb-10">
          <v-col cols="12" sm="6">
            <img
              class="about-image"
              :src="require('@/assets/me.jpg')"
              alt="Quentin Mennecart"
            />
          </v-col>
          <v-col cols="12" sm="6">
            <v-row>
              <v-col cols="12">
                Hello, I'm Quentin, a full stack developer, science communicant
                and photographer based in Norway. I have great experience in
                website/webapp creation, communication document creation and
                photography of nature. I am good at:
              </v-col>
              <v-col cols="12">
                <v-row justify="start">
                  <v-col cols="auto">
                    <v-chip outlined color="grey lighten-2">Javascript</v-chip>
                  </v-col>
                  <v-col cols="auto">
                    <v-chip outlined color="grey lighten-2">HTML</v-chip>
                  </v-col>
                  <v-col cols="auto">
                    <v-chip outlined color="grey lighten-2">CSS</v-chip>
                  </v-col>
                  <v-col cols="auto">
                    <v-chip outlined color="grey lighten-2">Vue.js</v-chip>
                  </v-col>
                  <v-col cols="auto">
                    <v-chip outlined color="grey lighten-2">Firebase</v-chip>
                  </v-col>
                  <v-col cols="auto">
                    <v-chip outlined color="grey lighten-2">InDesign</v-chip>
                  </v-col>
                  <v-col cols="auto">
                    <v-chip outlined color="grey lighten-2">Photography</v-chip>
                  </v-col>
                  <v-col cols="auto">
                    <v-chip outlined color="grey lighten-2">communication</v-chip>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" class="text-center mt-15">
                <v-btn x-large disabled>
                  Download my CV
                  <v-icon right dark>mdi-download</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {};
</script>

<style scoped>
.top-section {
  background-color: #1e2528 !important;
}
.line-divider {
  border-radius: 10px;
  background-image: linear-gradient(
    160deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(250, 250, 250) 88%
  );
  height: 5px;
  border: 0 none;
}

.about-image {
  width: 80%;
  border-radius: 100%;
  border: solid white 10px;
}
</style>
